import $ from 'jquery';
import {
  createCustomWidget,
  escapeAttr,
  createStatsWidget,
  createSearchBoxWidget,
  createClearAllWidget,
  createSaveSearchWidget,
  createCurrentRefinedWidget,
  createDescriptionWidget,
  createPaginationWidget,
  createDatePeriodWidget
} from '../../search/base_widgets';

window.WorkplaceWidgets = {
  locationWidget() {
    return instantsearch.widgets.refinementList({
      container: '#location',
      attribute: 'location',
      sortBy: ['isRefined'],
      limit: 5,
      operator: 'or',
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  clearAllWidget() {
    return createClearAllWidget();
  },

  currentRefinedValuesWidget() {
    return createCurrentRefinedWidget();
  },

  saveSearchWidget() {
    return createSaveSearchWidget();
  },

  invitedBiddersWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#invited-bidders',
      attribute: 'bidders_invited_count',
      templates: { submitText: '' }
    });
  },

  acceptedBiddersWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#accepted-bidders',
      attribute: 'bidders_accepted_count',
      templates: { submitText: '' }
    });
  },

  receivedBidsWidget() {
    return instantsearch.widgets.rangeInput({
      container: '#received-bids',
      attribute: 'bids_submitted_count',
      templates: { submitText: '' }
    });
  },

  // As this widget modifies two fields for some reason factory is not used
  biddingPeriodWidget() {
    return createCustomWidget({
      init(options) {
        $(document).on('click', '#clear-filters', () => $('#bidding_starts_at, #bidding_ends_at').datepicker('setDate', null));
        $(document).on('change', '#bidding_starts_at, #bidding_ends_at', function () {
          const bidding_starts_at = $('#bidding_starts_at').datepicker("getDate") / 1000;
          const bidding_ends_at = $('#bidding_ends_at').datepicker("getDate") / 1000;

          options.helper.removeNumericRefinement('bidding_starts_at', '>=');
          options.helper.removeNumericRefinement('bidding_ends_at', '<=');

          if (bidding_starts_at !== 0) {
            options.helper.addNumericRefinement('bidding_starts_at', '>=', bidding_starts_at);
          }
          if (bidding_ends_at !== 0) {
            options.helper.addNumericRefinement('bidding_ends_at', '<=', bidding_ends_at);
          }
          options.helper.search();
        });
      }
    });
  },

  tenderCreatedAtPeriodWidget() {
    return createDatePeriodWidget('#created_at_starts', '#created_at_ends')({ attribute: 'created_at' });
  },

  projectCreatedAtPeriodWidget() {
    return createDatePeriodWidget('#project_created_at_starts', '#project_created_at_ends')({ attribute: 'project_created_at' });
  },

  latestRfcCreatedAtPeriodWidget() {
    return createDatePeriodWidget('#latest_rfc_created_at_starts', '#latest_rfc_created_at_ends')({ attribute: 'latest_rfc_created_at' });
  },

  latestRfcCommentCreatedAtPeriodWidget() {
    return createDatePeriodWidget('#latest_rfc_comment_created_at_starts', '#latest_rfc_comment_created_at_ends')({ attribute: 'latest_rfc_comment_created_at' });
  },

  verifiersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#verifiers',
      attribute: 'verifiers',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search verifier",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  ownersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#owners',
      attribute: 'executive_officers',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search owner",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  developersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#developers',
      attribute: 'documenters',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search developer",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  biddersWidget() {
    return instantsearch.widgets.refinementList({
      container: '#bidders',
      attribute: 'bidders',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search bidder",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  auditorsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#auditors',
      attribute: 'auditors',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search auditor",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  evaluatorsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#evaluators',
      attribute: 'evaluators',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search evaluator",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  sectorsWidget() {
    return instantsearch.widgets.refinementList({
      container: '#sectors',
      attribute: 'sectors',
      operator: 'or',
      limit: 10,
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      },
      sortBy: ['isRefined']
    });
  },

  stateWidget(orderedStates) {
    return instantsearch.widgets.refinementList({
      container: '#state',
      attribute: 'formatted_state',
      operator: 'or',
      limit: 10,
      templates: {
        item(hit) {
          return `<label class='ais-RefinementList-label'><input type='checkbox' class='ais-RefinementList-checkbox' value="${escapeAttr(hit.value)}" ${hit.isRefined ? 'checked' : ''}><span class='status-label document-status label-project-status label-tender-status ${hit.value.toLowerCase().replace(/ /g, "_")}'>${hit.value}</span></input><span class='ais-RefinementList-count'>${hit.count}</span></label>`;
        }
      },
      sortBy(a, b) { return orderedStates.indexOf(a.name) < orderedStates.indexOf(b.name) ? -1 : 1; }
    });
  },

  evaluationStateWidget() {
    const orderedState = ["Draft", "In progress", "Completed"];
    return instantsearch.widgets.refinementList({
      container: '#evaluation-state',
      attribute: 'evaluation_state',
      operator: 'or',
      limit: 4,
      templates: {
        item(hit) {
          return `<label class='ais-RefinementList-label'><input type='checkbox' class='ais-RefinementList-checkbox' value="${escapeAttr(hit.value)}" ${hit.isRefined ? 'checked' : ''}><span class='status-label document-status label-project-status label-tender-status ${hit.value.toLowerCase().replace(/ /g, "_")}'>${hit.value}</span></input><span class='ais-RefinementList-count'>${hit.count}</span></label>`;
        }
      },
      sortBy(a, b) { return orderedState.indexOf(a.name) < orderedState.indexOf(b.name) ? -1 : 1; }
    });
  },

  docSetStatusWidget() {
    const orderedStatus = ['Draft', 'Submitted', 'Under Review', 'Approved', 'Rejected', 'Unverified'];
    return instantsearch.widgets.refinementList({
      container: '#doc-set-status',
      attribute: 'document_set_formatted_status',
      operator: 'or',
      limit: 10,
      templates: {
        item(hit) {
          return `<label class='ais-RefinementList-label'><input type='checkbox' class='ais-RefinementList-checkbox' value="${escapeAttr(hit.value)}" ${hit.isRefined ? 'checked' : ''}><span class='status-label document-status label-project-status ${hit.value.toLowerCase().replace(/ /g, "_")}'>${hit.value}</span></input><span class='ais-RefinementList-count'>${hit.count}</span></label>`;
        }
      },
      sortBy(a, b) { return orderedStatus.indexOf(a.name) < orderedStatus.indexOf(b.name) ? -1 : 1; }
    });
  },

  hasOpenDocumentIssuesWidget() {
    return instantsearch.widgets.toggleRefinement({
      container: '#open-doc-set-issues',
      attribute: 'open_issues',
      templates: { labelText: I18n.t('v4.projects.filters.labels.open_issues') },
      values: { on: true }
    });
  },

  hasOpenRfcsWidget(userRole = null) {
    if (typeof window.openRfcsFilterActive === 'undefined') {
      window.openRfcsFilterActive = false;
    }
    if (typeof window.openRfcsJustApplied === 'undefined') {
      window.openRfcsJustApplied = false;
    }

    return createCustomWidget({
      render(options) {
        const container = document.querySelector('#open-rfcs');
        if (!container) return;

        const searchInstance = window.WorkplaceTenders && window.WorkplaceTenders._tenderSearch;

        let hasOpenRfcsRefinement = false;
        try {
          if (searchInstance && searchInstance.helper && searchInstance.helper.state) {
            const numericRefinements = searchInstance.helper.state.numericRefinements || {};
            hasOpenRfcsRefinement = numericRefinements['open_rfcs'] && numericRefinements['open_rfcs'].length > 0;
          }
        } catch (e) {
          // Ignore errors
        }

        if (window.openRfcsJustApplied && hasOpenRfcsRefinement) {
          window.openRfcsJustApplied = false;
        }

        if (window.openRfcsFilterActive && !hasOpenRfcsRefinement) {
          setTimeout(() => {
            let stillNoRefinement = false;
            if (searchInstance && searchInstance.helper && searchInstance.helper.state) {
              const numericRefinements = searchInstance.helper.state.numericRefinements || {};
              stillNoRefinement = !(numericRefinements['open_rfcs'] && numericRefinements['open_rfcs'].length > 0);
            }
            if (stillNoRefinement && window.openRfcsFilterActive) {
              window.openRfcsFilterActive = false;
              window.openRfcsJustApplied = false;
            }
          }, 100);
        }

        const isChecked = window.openRfcsFilterActive;
        const existingCheckbox = container.querySelector('.open-rfcs-checkbox');
        if (existingCheckbox && existingCheckbox.checked === isChecked) return;

        container.innerHTML = `
          <label class="ais-RefinementList-label">
            <input type="checkbox" class="open-rfcs-checkbox" ${isChecked ? 'checked' : ''} />
            <span class="ais-RefinementList-labelText">${I18n.t('v4.tenders.filters.labels.open_rfcs')}</span>
          </label>
        `;

        const checkbox = container.querySelector('.open-rfcs-checkbox');
        if (checkbox) {
          checkbox.addEventListener('change', (e) => {
            window.openRfcsFilterActive = e.target.checked;
            if (!searchInstance || !searchInstance.helper) return;

            if (e.target.checked) {
              window.openRfcsJustApplied = true;
              searchInstance.helper.addNumericRefinement('open_rfcs', '>', 0).search();
            } else {
              window.openRfcsJustApplied = false;
              searchInstance.helper.removeNumericRefinement('open_rfcs');
              searchInstance.helper.search();
            }
          });
        }
      }
    });
  },

  phaseWidget() {
    const orderedPhase = ['RFP', 'Concept Design', 'Front-End Design', 'Construction'];
    return instantsearch.widgets.refinementList({
      container: '#phase',
      attribute: 'phase',
      operator: 'or',
      limit: 10,
      sortBy(a, b) { return orderedPhase.indexOf(a.name) < orderedPhase.indexOf(b.name) ? -1 : 1; }
    });
  },

  descriptionWidget() {
    return createDescriptionWidget('#description', ['title', 'plot_number', 'reference'], 'description');
  },

  searchBoxWidget(placeholder) {
    return createSearchBoxWidget({ placeholder });
  },

  statsWidget() {
    return createStatsWidget();
  },

  tendersHitsWidget() {
    const renderHits = function (renderOptions, isFirstRender) {
      if (isFirstRender) return;
      const { hits } = renderOptions;
      if (hits.length === 0) {
        return WorkplaceTenders.emptyCallHandler();
      } else {
        return WorkplaceTenders.reloadData(hits);
      }
    };
    return instantsearch.connectors.connectHits(renderHits);
  },

  projectsHitsWidget() {
    const renderHits = function (renderOptions, isFirstRender) {
      if (isFirstRender) return;
      const { hits } = renderOptions;
      if (hits.length === 0) {
        return WorkplaceProjects.emptyCallHandler();
      } else {
        return WorkplaceProjects.reloadData(hits);
      }
    };
    return instantsearch.connectors.connectHits(renderHits);
  },

  vendorRegistrationsHitsWidget() {
    const renderHits = function (renderOptions, isFirstRender) {
      if (isFirstRender) return;
      const { hits } = renderOptions;
      if (hits.length === 0) {
        return WorkplaceVendorRegistrations.emptyCallHandler();
      } else {
        return WorkplaceVendorRegistrations.reloadData(hits);
      }
    };
    return instantsearch.connectors.connectHits(renderHits);
  },

  registrationTypesWidget() {
    return instantsearch.widgets.refinementList({
      container: '#registration-types',
      attribute: 'registration_type',
      sortBy: ['isRefined'],
      limit: 5,
      searchablePlaceholder: "Search registration type",
      searchable: true,
      cssClasses: {
        searchableSubmit: 'hidden',
        searchableReset: 'hidden'
      }
    });
  },

  submittedAtWidget() {
    return createCustomWidget({
      init(options) {
        $(document).on('click', '#clear-filters', () => $('#submitted-at-starts, #submitted-at-ends').datepicker('setDate', null));
        $(document).on('change', "#submitted-at-starts, #submitted-at-ends", function () {
          const created_at_starts = $('#submitted-at-starts').datepicker("getDate") / 1000;
          const created_at_ends = $('#submitted-at-ends').datepicker("getDate") / 1000;
          const operator = $(this).prop('name').includes('starts') ? '>=' : '<=';
          options.helper.removeNumericRefinement('submitted_at', operator);
          if (created_at_starts !== 0) { options.helper.addNumericRefinement('submitted_at', '>=', created_at_starts); }
          if (created_at_ends !== 0) { options.helper.addNumericRefinement('submitted_at', '<=', created_at_ends); }
          options.helper.search();
        });
      }
    });
  },

  approvedAtWidget() {
    return createCustomWidget({
      init(options) {
        $(document).on('click', '#clear-filters', () => $('#approved-at-starts, #approved-at-ends').datepicker('setDate', null));
        $(document).on('change', "#approved-at-starts, #approved-at-ends", function () {
          const created_at_starts = $('#approved-at-starts').datepicker("getDate") / 1000;
          const created_at_ends = $('#approved-at-ends').datepicker("getDate") / 1000;
          const operator = $(this).prop('name').includes('starts') ? '>=' : '<=';
          options.helper.removeNumericRefinement('approved_at', operator);
          if (created_at_starts !== 0) { options.helper.addNumericRefinement('approved_at', '>=', created_at_starts); }
          if (created_at_ends !== 0) { options.helper.addNumericRefinement('approved_at', '<=', created_at_ends); }
          options.helper.search();
        });
      }
    });
  },

  validityWidget() {
    return createCustomWidget({
      init(options) {
        $(document).on('click', '#clear-filters', () => $('#valid-from, #valid-until').datepicker('setDate', null));
        $(document).on('change', "#valid-from, #valid-until", function () {
          const created_at_starts = $('#valid-from').datepicker("getDate") / 1000;
          const created_at_ends = $('#valid-until').datepicker("getDate") / 1000;
          options.helper.removeNumericRefinement($(this).prop('name').replace(/-/g, '_'));
          if (created_at_starts !== 0) { options.helper.addNumericRefinement('valid_from', '>=', created_at_starts); }
          if (created_at_ends !== 0) { options.helper.addNumericRefinement('valid_until', '<=', created_at_ends); }
          options.helper.search();
        });
      }
    });
  },

  paginationWidget() {
    return createPaginationWidget();
  }
};
